/**
 * Module-level identity of the command whose args are being filled. The doc
 * remains the source of truth for *what was typed* (arg words live as text
 * after the author mention); this mirror only records which installed command
 * the args suggestion applies to. It is set when a command is picked from the
 * '/' dropdown and rebuilt from the doc on editor init (draft restore).
 */

export type TActiveArgs = {
  pubkey: string
  d: string
}

let active: TActiveArgs | null = null
let activeArgIndex = -1

export function getActiveArgs(): TActiveArgs | null {
  return active
}

export function setActiveArgs(value: TActiveArgs | null) {
  active = value
  activeArgIndex = -1
}

/** index of the argument the args dropdown is currently filling */
export function getActiveArgIndex(): number {
  return activeArgIndex
}

export function setActiveArgIndex(value: number) {
  activeArgIndex = value
}
